import { Outlet } from "react-router-dom";
import SideNavbar from "../components/VTabBar/SideNavbar";
import {
  ChartBreakoutCircle,
  ChatBarIcon,
  DashboardIcon,
  DocumentTextIcon,
  GearIcon,
  LogOutIcon,
  QuotesIcon,
} from "../components/Icons";
import { RoutesType } from "./VTabBarLayout";
import AccountOverViewIcon from "../components/Icons/AccountOverViewIcon";

const routes = [
  {
    id: 1,
    route: "/admin/dashboard",
    name: "Dashboard",
    content: "This is Admin dashboard page for manage admin tasks",
    icon: <DashboardIcon className="size-6" />,
    disabled: false,
  },
  {
    id: 2,
    route: "/admin/customer-profiles",
    name: "Customer Profiles",
    content: "Admin customer profiles page for manage customer profiles",
    icon: <ChartBreakoutCircle className="size-6" />,
    disabled: false,
  },
  {
    id: 3,
    route: "/admin/rfqs",
    name: "RFQs",
    content: "Admin RFQs page for manage RFQs",
    icon: <ChartBreakoutCircle className="size-6" />,
    disabled: false,
  },
  {
    id: 4,
    route: "/admin/quotes",
    name: "Quotes",
    content: "Admin quotes page for manage quotes",
    icon: <ChartBreakoutCircle className="size-6" />,
    disabled: false,
  },
  {
    id: 5,
    route: "/admin/ongoing-orders",
    name: "Ongoing Orders",
    content: "Admin ongoing orders page for manage ongoing orders",
    icon: <ChartBreakoutCircle className="size-6" />,
    disabled: false,
  },
  {
    id: 6,
    route: "/admin/tasks",
    name: "Task",
    content: "Admin tasks page for manage user tasks",
    icon: <ChatBarIcon className="size-6" />,
    disabled: false,
  },
  {
    id: 7,
    route: "/admin/vendors",
    name: "Vendor Profiles",
    content: "Admin vendor profiles page for manage vendor profiles",
    icon: <QuotesIcon className="size-6" />,
    disabled: false,
  },
] satisfies RoutesType;

const bottomLinks = [
  {
    route: "/admin/account-overview",
    name: "Account Overview",
    icon: <AccountOverViewIcon className="size-6" />,
  },
  {
    route: "/admin/invoices",
    name: "Taram’s Invoices",
    icon: <DocumentTextIcon className="size-6" />,
  },

  {
    route: "/admin/security",
    name: "Security",
    icon: <GearIcon className="size-6" />,
  },
];

export default function AdminPanelLayout() {
  return (
    <main className="flex">
      <SideNavbar routes={routes} bottomLinks={bottomLinks} />

      <section className="flex-1 ml-[264px] min-h-screen pb-10 bg-[#EAECF0] transition-all duration-300 main_content">
        <AdminTopNavbar />

        <section
          className="max-w-[1128px] mx-auto mt-20"
          id="main_content_outlet"
        >
          <Outlet />
        </section>
      </section>
    </main>
  );
}

import LogOutBtn from "../components/LogOutBtn";
import Navbar from "../components/Shared/Navbar";

function AdminTopNavbar() {
  return (
    <Navbar>
      <LogOutBtn className="w-full p-1 rounded-lg hover:bg-red-50 flex items-center gap-1">
        <LogOutIcon className="size-5" /> <span>Log Out</span>
      </LogOutBtn>
    </Navbar>
  );
}
